import type { FC } from 'react';
import { isBlob, isImage, isPdf, isWord, useRouter } from '@application/utils';
import { FaFilePdf, FaFileWord } from 'react-icons/fa';

import * as Styled from './styled';
import type { FileViewerProps } from './types';

export const FileViewer: FC<FileViewerProps> = (props) => {
  const { file } = props;
  const { translate } = useRouter();

  if (!file) {
    return <Styled.FileContentWrapper>{translate('common.noFiles')}</Styled.FileContentWrapper>;
  }

  const shouldDisplayImage = (name: string) => {
    return isImage(name) || isBlob(name);
  };

  const href: string = typeof file === 'string' ? file : URL.createObjectURL(file);

  const onClick = () => {
    window.open(href, '_blank');
  };

  return (
    <Styled.FileContentWrapper>
      {shouldDisplayImage(href) && <Styled.ImageFile src={href} alt="" onClick={onClick} />}
      {isPdf(href) && (
        <Styled.File iconLeft={<FaFilePdf color="#d7dae0" />} color="transparent" onClick={onClick}>
          {href.split('/').pop()}
        </Styled.File>
      )}
      {isWord(href) && (
        <Styled.File
          iconLeft={<FaFileWord color="#d7dae0" />}
          color="transparent"
          onClick={onClick}
        >
          {href.split('/').pop()}
        </Styled.File>
      )}
    </Styled.FileContentWrapper>
  );
};
